<ng-container *ngIf="control.invalid && (control.dirty || control.touched)">
    <ng-container *ngFor="let validationError of validationErrors">
        <span *ngIf="!!this.control.errors[validationError.name]" [class.block]="!!this.control.errors[validationError.name]"
              class="text-danger-700">
            {{ getValidationErrorMessage(validationError) }}
        </span>
    </ng-container>
</ng-container>
